import { FC } from "react"
import SectionCell from "../../../../../section/cell"
import {
  EXCLUDED_MISC_DETAILS,
  MISC_FIELD_LABELS,
  MISC_FIELD_VALUES
} from "../../../../../../constants"
import { SubscriptionDetails } from "../../../../../../../types"

interface Props {
  data: SubscriptionDetails
}

const Misc: FC<Props> = ({ data }) => {
  const quote_info = data?.quote_info

  if (!quote_info) return null

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {Object.entries(quote_info).map(([key, value]) => {
        if (EXCLUDED_MISC_DETAILS.includes(key) || key === "quote_id")
          return null

        if (value === null || value === undefined) return null
        if (typeof value === "object") return null

        const stringValue = `${value}`
        if (stringValue === "") return null

        const label =
          MISC_FIELD_LABELS[key] ??
          key.replace(/_/g, " ").replace(/^./, (c: string) => c.toUpperCase())

        const valueLabel =
          key === "parent_url" || typeof value !== "string"
            ? stringValue
            : MISC_FIELD_VALUES[key]?.[stringValue] ??
              stringValue
                .replace(/_/g, " ")
                .replace(/^./, (c: string) => c.toUpperCase())

        return (
          <SectionCell
            key={key}
            truncateValue={key === "parent_url"}
            className={`!pt-0 break-all ${
              key === "parent_url" ? "row-span-2" : ""
            }`}
            label={label}
            value={valueLabel}
            h={"min-h-[1.75rem] h-auto"}
          />
        )
      })}

      <SectionCell
        key="quote_id"
        truncateValue={false}
        className="!pt-0 break-all"
        label="Quote id"
        value={quote_info.quote_id ? String(quote_info.quote_id) : "No Quote"}
        h={"min-h-[1.75rem] h-auto"}
      />
    </div>
  )
}

export default Misc
